// Mock data for humman landing page

export const faqData = {
  how_it_works: [
    {
      id: 1,
      question: "How does investing in founders work?",
      answer: "We provide direct capital ($500K-$1M USD) to exceptional founders in exchange for a percentage of their future professional income over 15 years. This includes salaries, bonuses, equity exits, and board fees."
    },
    {
      id: 2,
      question: "What exactly do I get with 'Fuel Injection'?",
      answer: "You receive immediate capital to secure your personal life and fund your next 3-5 years of company creation, without the survival pressure that distracts from execution excellence."
    },
    {
      id: 3,
      question: "How am I evaluated?",
      answer: "We use the F-100 Engine, an AI system that evaluates: 40% verified execution & ROI, 20% access to elite networks, 20% iteration speed, and 20% resilience to pivots."
    },
    {
      id: 4,
      question: "What happens if my startup fails?",
      answer: "That's precisely the point. Unlike traditional VC, your investment remains active. We keep betting on you as an individual, not on a specific company. You can pivot, start another company, or take executive roles."
    }
  ],
  how_it_doesnt: [
    {
      id: 5,
      question: "Is this a loan I have to repay?",
      answer: "No. It's not debt and has no mandatory monthly payments. You only share a percentage of your future income when you generate it. If you don't generate income, you don't pay."
    },
    {
      id: 6,
      question: "Do I lose control of my career decisions?",
      answer: "No. You maintain full autonomy over your professional and business decisions. We don't dictate what company to create or where to work. We're partners in your potential, not controllers."
    },
    {
      id: 7,
      question: "Is this for any entrepreneur?",
      answer: "No. Exclusive underwriting for the top 1%: serial founders, senior AI engineers, and industry leaders with high potential to generate tens of millions in personal wealth in the next decade."
    },
    {
      id: 8,
      question: "Do I need to have a startup already formed?",
      answer: "Not necessarily. We focus on the 'pre-company' stage: exceptional founders with proven track records, even before they have their next company defined."
    }
  ]
};

export const howItWorksData = [
  {
    id: 1,
    title: "Apply & Get Evaluated",
    description: "Submit your profile to the F-100 Engine. Our AI evaluates your execution track record, network access, velocity, and resilience.",
    icon: "scan"
  },
  {
    id: 2,
    title: "Receive Fuel Injection",
    description: "Get $500K-$1M USD upfront capital to secure your personal runway and focus 100% on building your next venture.",
    icon: "rocket"
  },
  {
    id: 3,
    title: "Build Without Pressure",
    description: "Create companies with financial immunity. No survival-mode decisions. Pure execution focus for the next 3-5 years.",
    icon: "shield"
  },
  {
    id: 4,
    title: "Share Your Success",
    description: "As you generate income over 15 years—salaries, exits, board fees—you share a percentage with your investors.",
    icon: "handshake"
  }
];

export const companyInfo = {
  name: "humman",
  tagline: "Invest in the engine, not the machine",
  subtitle: "The first Human Capital Protocol for high-velocity founders.",
  logoUrl: "/assets/logo.png"
};
